module.exports = __webpack_public_path__ + "static/media/ECI88_Fishing.c89e0ee2.png";